import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  authProvider?: string;
  hasGoogleCalendar?: boolean;
  hasPersonalGoogleCalendar?: boolean;
  avatarUrl?: string | null;
  bio?: string | null;
  ntfyTopic?: string | null;
  linkedCollaboratorId?: string | null;
  linkedExternalPhotographerId?: string | null;
  disabledAt?: string | null;
  permissions?: Record<string, boolean>;
}

interface AuthState {
  accessToken: string | null;
  user: User | null;
  twoFactorPending: boolean;
  pendingTwoFactorToken: string | null;
  setAuth: (token: string, user: User) => void;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setTwoFactorPending: (pending: boolean, token?: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      twoFactorPending: false,
      pendingTwoFactorToken: null,
      setAuth: (token, user) => set({ accessToken: token, user, twoFactorPending: false, pendingTwoFactorToken: null }),
      setToken: (token) => set({ accessToken: token }),
      setUser: (user) => set({ user }),
      setTwoFactorPending: (pending, token) => set({ twoFactorPending: pending, pendingTwoFactorToken: token ?? null, ...(token ? { accessToken: token } : {}) }),
      logout: () => set({ accessToken: null, user: null, twoFactorPending: false, pendingTwoFactorToken: null }),
    }),
    {
      name: 'lenscrm-auth',
      // Only persist the user profile for UI (name, role, etc.).
      // Do NOT persist the access token: it expires in 1h and a stale token
      // in localStorage would immediately trigger a failed refresh on page load.
      // The httpOnly refresh-token cookie handles silent re-auth transparently.
      partialize: (state) => ({ user: state.user, twoFactorPending: state.twoFactorPending, pendingTwoFactorToken: state.pendingTwoFactorToken }),
    }
  )
);
